// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"2f6d4c6f","229":"1a3a4d19","342":"35bbd4a1","453":"3d68e447","495":"721e34fe","712":"59210aa2"}[chunkId] + ".chunk.js";
};